import React from 'react';
import { DialogActions } from '@mui/material';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import { useDispatch } from 'react-redux';
import CreditLineStatus from '../../../../../../../../../common/creditLineStatus';
import { requestCreditLineValidated } from '../../../../../../../../../../../../../lib/api';
import { showAlert } from '../../../../../../../../../../../../../lib/functions/utils';

const ShoppingCartCreditLineMissingInfo = (props: any) => {
  const { setOpenShoppingCart, openRequest, setUp, setLoading } = props;
  const dispatch = useDispatch();

  const handleValidate = async () => {
    setLoading(true);
    try {
      await requestCreditLineValidated(dispatch, {
        id: openRequest.id,
        async: true,
      });
      setOpenShoppingCart(false);
      showAlert(
        dispatch,
        'success',
        'Hemos marcado como validada la solicitud, ahora pasará a revisión de riesgos',
      );
      await setUp();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <div>
      <div>
        <CreditLineStatus openRequest={openRequest} audienceType="received" />
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
          <CustomButton onClick={() => handleValidate()} color="primary">
            Validar
          </CustomButton>
        </DialogActions>
      </div>
    </div>
  );
};

export default ShoppingCartCreditLineMissingInfo;
